export const MAPS_API_KEY = 'AIzaSyD4M1ByZAncuxa8HzciLJYHRQ5IMdGc3yE';

let loadPromise = null;

export const loadGoogleMapsScript = () => {
  if (window.google && window.google.maps) {
    return Promise.resolve();
  }
  if (loadPromise) return loadPromise;
  loadPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${MAPS_API_KEY}`;
    script.async = true;
    script.defer = true;
    script.onload = () => {
      if (window.google && window.google.maps) resolve();
      else reject(new Error('Google Maps did not initialize'));
    };
    script.onerror = () => reject(new Error('Failed to load Google Maps script'));
    document.head.appendChild(script);
  });
  return loadPromise;
};
